import React from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { MdStorefront } from "react-icons/md";
import "react-lazy-load-image-component/src/effects/blur.css";
import { urlFor } from "../sanity/sanityClient";
import "./OrdersList.css";
import "./CategoryDisplay.css";
import { useStateContext } from '../context/StateContext';
import { toast } from 'react-hot-toast';

const CategoryDisplay = ({ categories, handleProductView }) => {
  const { setShowCart, onAdd } = useStateContext();
  
  const handleAddToCart = (product, index) => {
    if (!product) {
      toast.error("Product information is missing");
      return;
    }

    const productForCart = {
      ...product,
      quantity: 1,
      selectedIndex: index
    };

    const result = onAdd(productForCart, 1, index);
    if (result?.success) {
      setShowCart(true);
    }
  };

  return (
    <div className="category-display-container">
            
      {/* Categories Grid Section */}
      {categories && categories.length > 0 && (
        <div className="category-display-section">
          <div className="category-grid-five">
            {categories.map((category, index) => (
              <div 
                key={`${category._id}-${index}`} 
                className="category-grid-item" 
              >
                <Link 
                  to={`/category/${category.slug?.current}`} 
                  onClick={() => handleProductView(category._id, category._type)}
                  className="category-grid-link"
                >
                  <div className="category-image-wrapper">
                    {category.image[0] && (
                      <LazyLoadImage
                        src={urlFor(category.image[0])}
                        alt={category.name}
                        effect="blur"
                        className="category-grid-image"
                      />
                    )}
                    
                    {/* Status Sticker */}
                    {category.status && (
                      <span
                        className="category-status-sticker"
                        style={{
                          backgroundColor: category.status === 'available' ? 'rgba(34,197,94,0.8)' : 'rgba(239,68,68,0.8)'
                        }}
                      >
                        {category.status.toUpperCase()}
                      </span>
                    )}
                  </div>
                </Link>
                
                <div className="category-grid-details">
                  <h3 className="category-grid-name">{category.name}</h3>
                  <p className="category-grid-price">
                    {category.currency ? category.currency : 'Tzs'}: {category.price?.toLocaleString()}/=
                  </p>
                  {category.location && (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '8px',
                        width: '100%',
                        marginTop: '2px'
                      }}
                    >
                      <p
                        className="category-grid-location"
                        style={{
                          margin: 0,
                          flex: 1,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        🌍 {category.location}
                      </p>

                      <Link
                        to={`/shop/${category.user}`}
                        style={{
                          textDecoration: 'none',
                          color: '#111',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0
                        }}
                      >
                        <MdStorefront size={18} />
                      </Link>
                    </div>
                  )}
                  <button 
                    className="category-grid-button"
                    onClick={() => handleAddToCart(category, index)}
                    disabled={!category.price}
                  >
                    Buy Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryDisplay;